// WHICH AREA THIS BROWSER TAB IS IN, decided by HOST.
//
// Tenancy is by Host header (spec 16 §3.1.1): `<sub>.assessly.ai` is a tenant
// and `admin.<apex>` is the PLATFORM console, whose API surface
// (`/v1/platform/*`) answers on that host and nowhere else, and which has no
// tenant to resolve at all. The office/floor/onboarding areas are selected by
// PATH inside routes/root.tsx; the admin area is selected here, one step
// earlier, because it is the only area whose existence is a property of the
// host rather than of the URL the user typed.
//
// `admin` is a RESERVED subdomain (module 16's reserved list, D-012), so no
// tenant can ever be called `admin` and this test can never claim a tenant's
// host for the console.

/** The reserved leftmost label the platform console answers on. */
export const ADMIN_HOST_LABEL = "admin";

/** Is this hostname the platform console's (`admin.<apex>`)? */
export function isAdminHost(hostname: string): boolean {
  return hostname.split(".")[0] === ADMIN_HOST_LABEL;
}

/**
 * Paths that belong to the admin area ONLY.
 *
 * `/login` and `/` are deliberately absent: both exist on a tenant host too and
 * are decided by host at render time (routes/login.tsx). This list is what a
 * TENANT host must refuse — an office user who lands on `/accept-invite` gets
 * the designed 404, not a console screen wired to an API their host does not
 * serve.
 */
const ADMIN_ONLY_PATHS = ["/accept-invite", "/enroll", "/console"] as const;

export function isAdminOnlyPath(pathname: string): boolean {
  return ADMIN_ONLY_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
